export var context = {
  zIndex: 2000,
  lockCount: 0,
  stack: [],
  find: function find(vm) {
    return this.stack.filter(function (item) {
      return item.vm === vm;
    })[0];
  }
};


//////////////////
// WEBPACK FOOTER
// ./~/vant/es/mixins/popup/context.js
// module id = 266
// module chunks = 0